import { render } from "./WindowLoading.vue?vue&type=template&id=620c45a8&scoped=true"
import script from "./WindowLoading.vue?vue&type=script&lang=js"
export * from "./WindowLoading.vue?vue&type=script&lang=js"

import "./WindowLoading.vue?vue&type=style&index=0&id=620c45a8&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620c45a8"],['__file',"src/components/WindowLoading.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "620c45a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('620c45a8', __exports__)) {
    api.reload('620c45a8', __exports__)
  }
  
  module.hot.accept("./WindowLoading.vue?vue&type=template&id=620c45a8&scoped=true", () => {
    api.rerender('620c45a8', render)
  })

}


export default __exports__